import { makeStyles } from '@material-ui/core';
import themes from 'styles/themes';

export const useStyles = makeStyles((theme) => ({
    container: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: '16px',
    },
    styleContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        flexDirection: 'column',
        flex: 1,
    },
    heading: {
        fontSize: 14,
        fontWeight: 400,
        marginBottom: 16,
        textAlign: 'center',
        fontFamily: 'PoppinsRegular',
        color: '#767676',
        whiteSpace: 'pre',
    },
    option: {
        border: '1px solid #D1D1D1',
        padding: '12px 20px',
        borderRadius: '42px',
        marginLeft: '5px',
        marginRight: '5px',
        marginTop: '8px',
        fontSize: '14px',
        fontWeight: 400,
        fontFamily: 'PoppinsRegular',
    },
    optionContainer: {
        overflowY: 'auto',
        maxHeight: '100%',
        '&::-webkit-scrollbar': {
            width: '5px !important',
            display: 'flex',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#bfbfbf',
            borderRadius: '10px',
        },
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        background: 'white',
        borderRadius: '16px',
        padding: '16px 16px 24px 16px',
        justifyContent: 'center',
    },
    customTextField: {
        '& .MuiInputBase-root': {
            fontFamily: 'PoppinsRegular',
        },
        '& .MuiInput-underline': {
            '&.Mui-focused': {
                bottom: 0,
                borderBottom: 'none',
            },
            '&:before': {
                borderBottom: `1px solid ${themes.palette.grey['300']} !important`,
            },
            '&:after': {
                borderBottom: 'none',
            },
        },
    },
}));
